var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"extsdE2bJH8VhfSiYnp6O"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://examplePublicKey@o0.ingest.sentry.io/0',
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  release: process.env.SENTRY_RELEASE || undefined,
  // release resolves to the deployed commit SHA (see next.config.js env +
  // scripts/write-release.js); source maps upload under the same SHA.

  // Browser network-transport failures surface as unhandled fetch rejections
  // with no stack and no fix in app code: the request never reached us (user
  // offline/flaky connection, or the fetch was aborted when they navigated
  // away mid-request). Each browser phrases the same failure differently.
  // They are unactionable noise, so drop them at the source. Entries are matched
  // as substrings against the message, so every string here is an exact,
  // unambiguous network phrase — nothing generic enough to swallow a real bug.
  // (`Failed to fetch` can also mean CORS, but a real CORS break fails for every
  // user and shows up elsewhere; the noise is sparse and transient.)
  ignoreErrors: [
    'Load failed', // Safari
    'Failed to fetch', // Chrome/Edge
    'NetworkError when attempting to fetch resource.', // Firefox
    'The network connection was lost.', // iOS
    'The Internet connection appears to be offline.', // Safari offline
  ],
});
